// re-exports for customization
// TODO: add more if required
export * from './BottomToolbar';
export * from './AutoformControls';
export * from './I18nTools';
export * from './DuplicateButton';
export * from './Trash';
export * from './ImageUpload';
export * from './SelectParentButton';
export * from './PluginDrawer';
export * from './ColorPicker';
export * from './Sidebar';
export * from './defaultTheme';
//# sourceMappingURL=index.js.map